<template>
  <div class="team-registration">
    <app-form class="team-registration__form" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AppForm from '@/components/Form.vue'

import { i18n } from '@shared/i18n'

export default {
  name: 'team-registration',
  data() {
    return {
      i18n,
    }
  },
  computed: {
    ...mapState('form', ['hasAcceptedTerms']),
  },
  mounted() {
    if (!this.hasAcceptedTerms) this.$router.push({
      name: 'home',
      params: {
        slug: this.$route.params.slug,
      }
    })
  },
  components: {
    AppForm,
  },
}
</script>

<style lang="scss" scoped>
.team-registration {
  background: #ffffff;

  &__form {
    margin: 0;

    @include tablet {
      margin: 0 32px;
    }
  }
}
</style>
